import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { clearAdminSession } from '../utils/accountAccess';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Logout iniciado...");

    const doLogout = async () => {
      try {
        await axios.post('/api/auth/logout');
      } catch (error) {
        console.error("Erro durante o logout:", error);
      } finally {
        clearAdminSession();
        console.log("Token removido, redirecionando...");
        navigate('/login', { replace: true });
      }
    };

    doLogout();
  }, [navigate]);

  return <p>Realizando logout...</p>;
};

export default Logout;
